import React from 'react';
import styled from 'styled-components';
import { ReactSVG } from 'react-svg';
import { ToolType } from '../../../hooks/useEditorCanvas';
import { colors } from '../../const/Styles';

type ContainerProps = {
    selected: boolean;
};
const Container = styled.i<ContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    > span {
        display: flex;
        flex-direction: row;

        span {
            display: flex;
            flex-direction: row;
        }

        svg {
            circle {
                fill: ${({ selected }) => selected ? colors.lightGray : colors.black};
            }
            width: 38px;
            height: 38px;
        }
    }
`;

const Label = styled.label<{ isBackgroundDark?: boolean }>`
    display: block;
    color: ${(props) => (props.isBackgroundDark ? colors.white : colors.black)};
    font-size: 10px;
`;

type Props = {
    icon: string;
    value: ToolType;
    selected: ToolType;
    onClick?: (value: ToolType) => void;
    isBackgroundDark?: boolean;
};

const ToolItem: React.FC<Props> = ({
    icon,
    value,
    selected,
    onClick,
    children,
    isBackgroundDark = true,
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick(value);
        }
    };
    return (
        <Container selected={value === selected} onClick={handleClick}>
            <ReactSVG src={icon} wrapper='span' />
            <Label isBackgroundDark={isBackgroundDark}>{children}</Label>
        </Container>
    );
};

export default ToolItem;
